import { createApp } from 'vue';
import Dashboard from './Components/DashboardWidget/dashboard.vue';
import { createPinia } from "pinia";
import '../node_modules/element-plus/theme-chalk/src/notification.scss';
import './Assets/dashboardWidget.scss';

const pinia = createPinia();
const dashboardWidgetApp = createApp(Dashboard);
dashboardWidgetApp.use(pinia);


dashboardWidgetApp.mount('#fv-dashboard-widgets-0');